<script>
	import OutboundLink from 'components/outbound-link.vue';
	import { assetUrl } from 'utilities/urlUtilities';

	export default {
		components: {
			'outbound-link': OutboundLink
		},
		props: {
			name: {
				type: String,
				default: 'content_partners'
			}
		},
		data() {
			return {
				contentPartners: {
					title: 'Content Partners',
					subtitle: 'We partner with museums, cultural institutions, and other content-area experts to bring world-class content to students.',
					partners: [
						{
							link: 'https://www.amnh.org/',
							imgSrc: '/assets/dist/images/content-partners/american-mnh.svg',
							alt: 'American Museum of Natural History',
							tag: 'AMERICAN_MUSEUM_OF_NATURAL_HISTORY'
						},
						{
							link: 'https://www.nfwf.org/',
							imgSrc: '/assets/dist/images/content-partners/nfwf.svg',
							alt: 'National Fish and Wildlife Foundation',
							tag: 'NATIONAL_FISH_AND_WILDLIFE_FOUNDATION'
						},
						{
							link: 'https://www.internationalquiltmuseum.org/',
							imgSrc: '/assets/dist/images/content-partners/international-quilt-museum.png',
							alt: 'International Quilt Museum',
							tag: 'INTERNATIONAL_QUILT_MUSEUM'
						},
						{
							link: 'https://as.vanderbilt.edu/clacx/',
							imgSrc: '/assets/dist/images/content-partners/vanderbilt-clacx.png',
							alt: 'CLACX, Vanderbilt University College of Liberal Arts - Center for Latin American, Caribbean, and Latinx Studies',
							tag: 'VANDERBILT_CFLAS'
						},
						{
							link: 'https://www.gilderlehrman.org/',
							imgSrc: '/assets/dist/images/content-partners/gilder-lehrman.svg',
							alt: 'The Gilder Lehrman Institute of American History',
							tag: 'GILDER_LEHRMAN_INSTITUTE'
						},
						{
							link: 'https://www.nyhistory.org/',
							imgSrc: '/assets/dist/images/content-partners/ny-historical-society.svg',
							alt: 'New York Historical Society Museum & Library',
							tag: 'NY_HISTORICAL_SOCIETY'
						},
						{
							link: 'https://www.exploratorium.edu/',
							imgSrc: '/assets/dist/images/content-partners/exploratorium.svg',
							alt: 'Exploratorium',
							tag: 'EXPLORATORIUM'
						},
						{
							link: 'https://www.moma.org/',
							imgSrc: '/assets/dist/images/content-partners/moma.svg',
							alt: 'Museum of Modern Art',
							tag: 'MOMA'
						},
						{
							link: 'https://www.audubon.org/',
							imgSrc: '/assets/dist/images/content-partners/audubon.svg',
							alt: 'The National Audubon Society',
							tag: 'AUDUBON_SOCIETY'
						},
						{
							link: 'https://philamuseum.org/',
							imgSrc: '/assets/dist/images/content-partners/philadelphia-moa.svg',
							alt: 'Philadelphia Museum of Art',
							tag: 'PHILADELPHIA_MUSEUM_OF_ART'
						},
						{
							link: 'https://www.nypl.org/locations/schomburg',
							imgSrc: '/assets/dist/images/content-partners/schomburg-center.png',
							alt: 'Schomburg Center for Research in Black Culture, The New York Public Library',
							tag: 'SCHOMBURG_CENTER'
						},
						{
							link: 'https://www.history.com/',
							imgSrc: '/assets/dist/images/content-partners/history.svg',
							alt: 'History Channel',
							tag: 'HISTORY'
						},
						{
							link: 'https://www.readingplus.com/',
							imgSrc: '/assets/dist/images/content-partners/reading-plus.png',
							alt: 'Dreambox Reading Plus',
							tag: 'DREAMBOX_READING_PLUS'
						},
						{
							link: 'https://www.wsj.com/',
							imgSrc: '/assets/dist/images/content-partners/wall-street-journal.svg',
							alt: 'The Wall Street Journal',
							tag: 'WALL_STREET_JOURNAL'
						},
						{
							link: 'https://nyphil.org/',
							imgSrc: '/assets/dist/images/content-partners/ny-phil.svg',
							alt: 'New York Philharmonic',
							tag: 'NEW_YORK_PHILHARMONIC'
						}
					]
				},
				learningPartners: {
					title: 'Learning Partners',
					subtitle: 'We partner with leading organizations and districts on shared teaching and learning goals.',
					partners: [
						{
							link: 'https://www.issnc.org/',
							imgSrc: '/assets/dist/images/learning-partners/iredell-statesville-schools.png',
							alt: 'Iredell-Statesville Schools',
							tag: 'IREDELL-STATESVILLE_SCHOOLS'
						},
						{
							link: 'https://www.schools.nyc.gov/',
							imgSrc: '/assets/dist/images/learning-partners/nycps.png',
							alt: 'New York City Public Schools',
							tag: 'NYC_PUBLIC_SCHOOLS'
						},
						{
							link: 'https://www.wordsmyth.net/',
							imgSrc: '/assets/dist/images/learning-partners/wordsmyth.png',
							alt: 'Wordsmyth: The Premier Educational Dictionary - Thesaurus',
							tag: 'WORDSMYTH'
						},
						{
							link: 'https://en.tailor-ed.com/explore',
							imgSrc: '/assets/dist/images/learning-partners/tailor-ed.png',
							alt: 'Tailor Ed',
							tag: 'TAILOR_ED'
						},
						{
							link: 'https://amplify.com/',
							imgSrc: '/assets/dist/images/learning-partners/amplify.svg',
							alt: 'Amplify',
							tag: 'AMPLIFY'
						},
						{
							link: 'https://www.microsoft.com',
							imgSrc: '/assets/dist/images/learning-partners/microsoft.svg',
							alt: 'Microsoft',
							tag: 'MICROSOFT'
						},
						{
							link: 'https://eleducation.org/',
							imgSrc: '/assets/dist/images/learning-partners/el-education.svg',
							alt: 'EL Education',
							tag: 'EL_EDUCATION'
						},
						{
							link: 'https://whole-phonics.com/',
							imgSrc: '/assets/dist/images/learning-partners/whole-phonics.png',
							alt: 'Whole Phonics: A New Chapter in Literacy Instruction',
							tag: 'WHOLE_PHONICS'
						},
						{
							link: 'https://www.niea.org/',
							imgSrc: '/assets/dist/images/learning-partners/niea.png',
							alt: 'National Indian Education Association',
							tag: 'NIEA'
						},
						{
							link: 'https://www.teachingmatters.org/',
							imgSrc: '/assets/dist/images/learning-partners/teaching-matters.png',
							alt: 'Teaching Matters: Great Teachers. Bright Futures',
							tag: 'TEACHING_MATTERS'
						},
						{
							link: 'https://www.read718.org/',
							imgSrc: '/assets/dist/images/learning-partners/read-718.jpg',
							alt: 'Read 718',
							tag: 'READ_718'
						},
						{
							link: 'https://beable.com/',
							imgSrc: '/assets/dist/images/learning-partners/beable.jpg',
							alt: 'Beable',
							tag: 'BEABLE'
						},
						{
							link: 'https://textproject.org',
							imgSrc: '/assets/dist/images/learning-partners/text-project.png',
							alt: 'Text Project',
							tag: 'TEXT_PROJECT'
						}
					]
				}
			};
		},
		computed: {
			currentPartners() {
				return this.name === 'content_partners' ? this.contentPartners : this.learningPartners;
			}
		},
		methods: {
			assetUrl(url) {
				return assetUrl(url);
			}
		}
	};
</script>
<style lang="scss">
	@import 'mixins/media';

	.partners-panel {
		padding: 4rem 0;

		h2,
		.sub-heading {
			text-align: center;
		}

		h2 {
			margin: 0 0 2rem;
		}

		.partner-list {
			--partner-column-width: 50%;
			--partner-column-spacing: 0.5rem;
			margin: 2rem calc(-1 * var(--partner-column-spacing)) 0;
			display: flex;
			flex-wrap: wrap;
			justify-content: center;

			@include media(med) {
				--partner-column-width: 33.333%;
				--partner-column-spacing: 0.75rem;
			}

			@include media(lg) {
				--partner-column-width: 20%;
				--partner-column-spacing: 1rem;
			}
		}

		.partner {
			margin: var(--partner-column-spacing);
			flex-basis: calc(var(--partner-column-width) - 2 * var(--partner-column-spacing));
		}

		.partner-link {
			display: block;
			height: 5rem;
			padding: 1rem 1.25rem;
			border-radius: 1.25rem;

			img {
				object-fit: contain;
				object-position: center center;
				height: 100%;
				width: 100%;
			}
		}
	}
</style>
<template>
	<section :class="['partners-panel', name]">
		<div class="wrapper">
			<h2
				:id="`partner-panel-title-${name}`"
				:class="{ 'has-sub-heading': currentPartners.subtitle }">
				{{ currentPartners.title }}
			</h2>
			<p
				v-if="currentPartners.subtitle"
				class="sub-heading panel-content">
				{{ currentPartners.subtitle }}
			</p>
			<ul
				class="partner-list list-unstyled"
				:aria-labelledby="`partner-panel-title-${name}`">
				<li
					v-for="partner in currentPartners.partners"
					:key="partner.link"
					class="partner">
					<outbound-link
						class="partner-link panel-card panel-action"
						:href="partner.link"
						:data-outbound-link="partner.tag">
						<img
							loading="lazy"
							:src="assetUrl(partner.imgSrc)"
							:alt="partner.alt" />
					</outbound-link>
				</li>
			</ul>
		</div>
	</section>
</template>
